// Allowing unused expessions in here, because we want to make as few modifications as possible to
// the original CKEditor code.
/* eslint-disable eqeqeq, no-nested-ternary, no-unused-expressions */
define((require) => {
    "use strict";

    var _            = require("underscore"),
        WebFontsUtil = require("shared/ui/experience/fonts/WebFontsUtil");

    return {
        /**
         * Patch CKEditor for out needs: 1) Don't block the Backspace key and 2) quote font family
         * names.
         *
         * @param {Ckeditor} CKEDITOR CKEditor object. Using an all uppercase name to match
         *                            CKEditor's code style.
         */
        patch: function(CKEDITOR) {
            CKEDITOR.skin.loadPart = function(part, fn) {
                if (_.isFunction(fn)) {
                    fn.call(CKEDITOR.skin);
                }
            };

            var superSetReadOnly = CKEDITOR.editor.prototype.setReadOnly;

            /**
             * The default implementation of CKEDITOR.editor#setReadOnly blocks the BACKSPACE
             * key according to current read-only state.
             *
             * We need the BACKSPACE event for deleting widgets (MOS-1734).
             *
             * @override
             * @see CKEDITOR.editor#setReadOnly
             */
            CKEDITOR.editor.prototype.setReadOnly = function(isReadOnly) {
                superSetReadOnly.call(this, isReadOnly);
                // Make sure BACKSPACE is not blocked
                this.keystrokeHandler.blockedKeystrokes[8] = 0;
            };

            /**
             * Override to inject our call to _quoteSpecialFontNames.
             * @override
             */
            CKEDITOR.htmlParser.prototype.cssStyle = function() {
                // Loosining up the rules for CKEditor code.

                var styleText,
                    arg = arguments[0],
                    rules = {};

                styleText = arg instanceof CKEDITOR.htmlParser.element ? arg.attributes.style : arg;

                // html-encoded quote might be introduced by 'font-family'
                // from MS-Word which confused the following regexp. e.g.
                // 'font-family: &quot;Lucida, Console&quot;'
                // TODO reuse CSS methods from tools.
                (styleText || "").replace(/&quot;/g, "\"").replace(/\s*([^ :;]+)\s*:\s*([^;]+)\s*(?=;|$)/g, (match, name, value) => {
                    name == "font-family" && (value = value.replace(/["']/g, ""));

                    // Zmags patch start.
                    value = _quoteSpecialFontNames(name, value);
                    // Zmags patch end.

                    rules[name.toLowerCase()] = value;
                });

                return {
                    rules: rules,

                    /**
                     * Applies the styles to the specified element or object.
                     *
                     * @param {CKEDITOR.htmlParser.element/CKEDITOR.dom.element/Object} obj
                     */
                    populate: function(obj) {
                        var style = this.toString();
                        if (style) {
                            if (obj instanceof CKEDITOR.dom.element) {
                                obj.setAttribute("style", style);
                            } else if (obj instanceof CKEDITOR.htmlParser.element) {
                                obj.attributes.style = style;
                            } else {
                                obj.style = style;
                            }
                        }
                    },

                    /**
                     * Serializes CSS style declaration to a string.
                     *
                     * @returns {String}
                     */
                    toString: function() {
                        var output = [];
                        for (var i in rules) {
                            rules[i] && output.push(i, ":", rules[i], ";");
                        }

                        return output.join("");
                    }
                };
            };

            /**
             * Override to inject our call to _quoteSpecialFontNames.
             * @override
             */
            CKEDITOR.tools.parseCssText = function(styleText, normalize, nativeNormalize) {
                // Loosining up the rules for CKEditor code.

                var retval = {};

                if (nativeNormalize) {
                    // Injects the style in a temporary span object, so the browser parses it,
                    // retrieving its final format.
                    var temp = new CKEDITOR.dom.element("span");
                    temp.setAttribute("style", styleText);
                    styleText = CKEDITOR.tools.convertRgbToHex(temp.getAttribute("style") || "");
                }

                // IE will leave a single semicolon when failed to parse the style text. (#3891)
                if (!styleText || styleText == ";") {
                    return retval;
                }

                styleText.replace(/&quot;/g, "\"").replace(/\s*([^:;\s]+)\s*:\s*([^;]+)\s*(?=;|$)/g, (match, name, value) => {
                    if (normalize) {
                        name = name.toLowerCase();
                        // Normalize font-family property, ignore quotes and being case insensitive. (#7322)
                        // http://www.w3.org/TR/css3-fonts/#font-family-the-font-family-property
                        if (name == "font-family") {
                            value = value.toLowerCase().replace(/["']/g, "").replace(/\s*,\s*/g, ",");
                        }
                        value = CKEDITOR.tools.trim(value);

                        // Zmags patch start.
                        value = _quoteSpecialFontNames(name, value);
                        // Zmags patch end.
                    }

                    retval[name] = value;
                });

                return retval;
            };

            function _quoteSpecialFontNames(name, value) {
                if (name === "font-family") {
                    value = WebFontsUtil.quoteSpecialFontNames(value);
                }

                return value;
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textWidget/textEditor/CkeditorPatcher.js